(function () {
  'use strict';

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function initCarousel(track) {
    var root = track.closest('.bestseller-products__carousel') || track.parentElement;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!prev || !next) return;

    function step() {
      var item = track.querySelector('.bestseller-products__item');
      return item ? item.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
  }

  qsa('[data-carousel-track]').forEach(initCarousel);
})();
